import { z } from 'zod';

import { createProposedActionsApi } from '@/shared/api/lotus';

import { defineToolSpec, toToolInputJsonSchema } from '../../types';
import {
  buildApplyModificationsErrorText,
  nonEmptyStringSchema,
  type ApiRemoveModification,
} from './shared';

const inputSchema = z.object({
  external_id: nonEmptyStringSchema,
});

type DeleteProposedActionInput = z.infer<typeof inputSchema>;

const TOOL_NAME = 'delete_proposed_action';

export function createDeleteProposedActionToolSpec(patientUserId: string) {
  const api = createProposedActionsApi();

  return defineToolSpec({
    name: TOOL_NAME,
    inputSchema,
    getDefinition: () => ({
      name: TOOL_NAME,
      description:
        'Delete one proposed action from the care plan. Example input: {"external_id":"rx-lisinopril"}.',
      input_schema: toToolInputJsonSchema(inputSchema),
    }),
    async handle(input: DeleteProposedActionInput) {
      try {
        const modification: ApiRemoveModification = {
          type: 'remove',
          external_id: input.external_id,
        };

        const result = await api.applyModifications(patientUserId, [modification]);
        return { output: result };
      } catch (error: unknown) {
        return { errorText: buildApplyModificationsErrorText(error) };
      }
    },
  });
}
